/**
 * 主题切换 Model
 * 支持亮色/暗色主题，持久化到 localStorage
 */
import { useCallback, useState } from 'react';

export type ThemeMode = 'light' | 'dark';

const STORAGE_KEY = 'admin_theme_mode';

function readStoredTheme(): ThemeMode {
  try {
    const val = localStorage.getItem(STORAGE_KEY);
    if (val === 'dark' || val === 'light') return val;
  } catch {
    // ignore
  }
  return 'light';
}

export default function useThemeModel() {
  const [themeMode, setThemeMode] = useState<ThemeMode>(readStoredTheme);

  const updateTheme = useCallback((mode: ThemeMode) => {
    setThemeMode(mode);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      // ignore
    }
  }, []);

  const toggleTheme = useCallback(() => {
    const next = themeMode === 'light' ? 'dark' : 'light';
    updateTheme(next);
  }, [themeMode, updateTheme]);

  return {
    themeMode,
    setThemeMode: updateTheme,
    toggleTheme,
    isDark: themeMode === 'dark',
  };
}
